// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormField, FormState } from "@adl/XDL/Utilities/form";
import translate from "@insite/client-framework/Translate";

export interface SpecialRequestItemsFormState extends FormState {
    fields: {
        qtyNeeded: FormField<string>;
        partNumber: FormField<string>;
        description: FormField<string>;
    };
}

export const initialSpecialRequestItemsFormState: SpecialRequestItemsFormState = {
    isValid: false,
    isSubmitted: false,
    fields: {
        qtyNeeded: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_qtyNeeded",
                name: "qtyNeeded",
                label: translate("Qty Needed"),
                placeholder: translate("Enter Qty Needed"),
                required: true,
                maxLength: 6,
            },
        },
        partNumber: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_partNumber",
                name: "partNumber",
                label: translate("Part Number"),
                placeholder: translate("Enter Part Number"),
                required: true,
                maxLength: 40,
            },
        },
        description: {
            value: "",
            validators: ["required"],
            attrs: {
                id: "SpecialRequest_description",
                name: "description",
                label: translate("Description"),
                placeholder: translate("Enter Description"),
                required: true,
                maxLength: 500,
            },
        },
    },
};
